<template>
  <!-- viewBox="0 0 12 12" -->
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.15332 0.512472C7.83673 -0.170798 8.94455 -0.17085 9.62793 0.512472L11.4883 2.37282C12.1712 3.05623 12.1714 4.16415 11.4883 4.84743L4.84766 11.4881C4.51959 11.8161 4.0743 12.0006 3.61035 12.0008H1.25C0.559783 12.0008 0.000223955 11.4409 0 10.7508L0 8.3904C4.06533e-05 7.92633 0.184546 7.48125 0.512695 7.1531L7.15332 0.512472ZM1.57324 8.21364C1.52639 8.26049 1.50004 8.32415 1.5 8.3904L1.5 10.5008H3.61035C3.67647 10.5006 3.74034 10.4743 3.78711 10.4275L8.34863 5.86501L6.13477 3.65114L1.57324 8.21364ZM8.56738 1.57302C8.46979 1.47548 8.31149 1.47554 8.21387 1.57302L7.19531 2.5906L9.40918 4.80446L10.4277 3.78689C10.5251 3.68939 10.5249 3.53099 10.4277 3.43337L8.56738 1.57302Z"
    fill="currentColor"
  />
</template>
